import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsparkInputNumberComponent } from './inspark-input-number/inspark-input-number.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [InsparkInputNumberComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule

  ],
  exports: [InsparkInputNumberComponent]
})
export class InsparkInputNumberModule { }
